/** Search-engine and social crawlers: their errors are not real users' errors. */
const CRAWLER_PATTERN: RegExp = /bot\b|crawler|spider|slurp|bingpreview|facebookexternalhit|embedly|headlesschrome/i;

export function isCrawler(userAgent: string | null | undefined): boolean {
  return !!userAgent && CRAWLER_PATTERN.test(userAgent);
}
